export const firebaseConfig = {
  apiKey: "AIzaSyBj5Ucfix7MIAqou9c0SN7MFQTHtLj0wUQ",
  authDomain: "debate-miraldure.firebaseapp.com",
  databaseURL: "https://debate-miraldure.firebaseio.com",
  projectId: "debate-miraldure",
  storageBucket: "debate-miraldure.appspot.com",
  messagingSenderId: "239109147238",
  appId: "1:239109147238:web:0869ad5502b52962"
};
